// Mock data for CATV website

export const siteConfig = {
  name: "CATV",
  fullName: "Clube de Atletismo de Torres Vedras",
  tagline: "Promovendo o atletismo, a saúde e o espírito desportivo na comunidade de Torres Vedras.",
  email: "info@catv.pt",
  phone: "+351 912 331 621",
  whatsapp: "https://wa.me/351912331621",
  whatsappNumber: "+351 912 331 621",
  location: "Torres Vedras, Portugal",
  instagram: "https://www.instagram.com/clubeatletismotv",
  facebook: "https://www.facebook.com/61577961272317",
  registrationUrl: "/inscricoes",
  trialUrl: "https://docs.google.com/forms/d/12H-XNKcj8wAYE1yR_azwqGXEHpIt7JGiAkYEFn4MzO4/viewform?chromeless=1&edit_requested=true",
  founded: 2025,
  logoTransparent: "/catv/images/logo_azul-removebg-preview.png",
  logoBlue: "/catv/images/logo_azul.png",
};

export const navigationLinks = [
  { label: "Início", path: "/" },
  { label: "Equipa", path: "/equipa" },
  { label: "Inscrições", path: "/inscricoes" },
];

export const heroImage = "/catv/images/hero_imagem.png";

export const aboutFeatures = [
  {
    id: 1,
    icon: "GraduationCap",
    title: "Formação",
    description:
      "Programas de treino para todas as idades e níveis, dos iniciantes aos atletas de competição.",
  },
  {
    id: 2,
    icon: "Users",
    title: "Equipa",
    description:
      "Uma equipa dedicada de treinadores e atletas que trabalham juntos para alcançar a excelência.",
  },
  {
    id: 3,
    icon: "Trophy",
    title: "Competição",
    description:
      "Participação activa em competições regionais e nacionais com resultados de destaque.",
  },
];

export const stats = [
  { id: 1, value: "1", label: "Ano de história" },
  { id: 2, value: "69", label: "Atletas" },
  { id: 3, value: "3", label: "Treinadores certificados" },
];

export const coaches = [
  {
    id: 1,
    name: "Ricardo Ferreira",
    role: "Presidente | Treinador de Atletismo Grau I",
    image: "https://catv.pt/imagens/treinadores/RF.jpg",
    bio: [
      "Presidente do CATV",
      "Treinador de Atletismo Grau I",
      "Coordenação técnica das escolas",
      "Formação e captação de atletas",
      "Representação em competições nacionais",
    ],
  },
  {
    id: 2,
    name: "Ricardo Vitorino",
    role: "VP | Treinador de Atletismo Grau I",
    image: "https://catv.pt/imagens/treinadores/RV.jpg",
    bio: [
      "Cofundador da Academia de Atletismo do Furadouro",
      "Cofundador da Academia SCUT Athletics",
      "Internacional Português no IWAS",
      "Estágio Nacional Meio Fundo & Marcha (2025)",
      "Vários atletas em Campeonatos Nacionais e Internacionais",
    ],
  },
  {
    id: 3,
    name: "Vanessa Soares",
    role: "Treinadora de Atletismo Grau I",
    image: "https://catv.pt/imagens/treinadores/V.jpg",
    bio: [
      "Treinadora de velocidade e barreiras",
      "Apoio técnico às equipas jovens",
      "Planeamento de época e avaliações",
      "Participação em formações da FPA",
      "Acompanhamento em provas oficiais",
    ],
  },
  {
    id: 4,
    name: "Neusa Sampaio",
    role: "Treinadora Estagiária de Atletismo Grau I",
    image: "https://catv.pt/imagens/treinadores/N.jpg",
    bio: [
      "Apoio às camadas jovens",
      "Formação contínua em metodologias",
      "Monitorização técnica em treinos",
      "Gestão de grupos em competições",
      "Relação com encarregados de educação",
    ],
  },
  {
    id: 5,
    name: "Marta Conceição",
    role: "Treinadora de Atletismo Grau I",
    image: "https://catv.pt/imagens/treinadores/M.jpg",
    bio: [
      "Especialista em iniciação desportiva",
      "Foco no desenvolvimento motor",
      "Planeamento de sessões lúdicas",
      "Acompanhamento técnico em prova",
      "Integração de novos atletas",
    ],
  },
];

export const opportunities = [
  {
    id: 1,
    title: "Oportunidades de Trabalho",
    description:
      "Consulte as nossas ofertas de emprego para treinadores, fisioterapeutas e outros profissionais.",
    image: "https://catv.pt/imagens/Pagina_equipa/Trabalho.png",
    cta: "Saiba mais",
  },
  {
    id: 2,
    title: "Estágios",
    description:
      "Precisamos de voluntários para eventos, competições e atividades do clube.",
    image: "https://catv.pt/imagens/Pagina_equipa/Estagio.png",
    cta: "Saiba mais",
  },
];

export const registrationInfo = {
  title: "Inscrições Época 2025/26",
  paragraphs: [
    "Bem-vindo/a ao formulário de inscrição do CATV – Clube de Atletismo de Torres Vedras!",
    "É com grande satisfação que recebemos a tua inscrição para a nova época desportiva. Este formulário serve para novos atletas e para a renovação de inscrições.",
    "Preenche todos os campos com atenção e dados verdadeiros. As informações recolhidas serão usadas apenas para fins administrativos, seguros e comunicação interna.",
    "Para menores de idade, o formulário deve ser preenchido por um encarregado de educação.",
    "Em caso de dúvidas, contacta-nos pelo e-mail info@catv.pt ou através das nossas redes sociais.",
    "Obrigado pela confiança! Juntos vamos tornar esta época inesquecível!",
  ],
  steps: [
    {
      id: 1,
      title: "Preenche o formulário",
      description: "Completa os teus dados pessoais e do encarregado de educação (se menor).",
    },
    {
      id: 2,
      title: "Envia a inscrição",
      description: "Submete o formulário oficial e aguarda confirmação por e-mail.",
    },
    {
      id: 3,
      title: "Bem-vindo ao clube",
      description: "Recebes informação sobre treinos, equipamento e calendário de competições.",
    },
  ],
  documents: [
    "Documento de identificação do atleta",
    "NIF do atleta",
    "Contacto do encarregado de educação (menores)",
    "Declaração médica (se aplicável)",
  ],
};
